<template>
  <div>
    <div v-if="users && state == 'VIEW'">
      <b-row class="mb-4">
        <b-col class="mt-4">
          <b-form-checkbox switch size="sm" v-model="active" @change="bind"
            >Active Users</b-form-checkbox
          >
        </b-col>
        <b-col class="text-right">
          <b-button variant="primary" @click="newUser">Create User</b-button>
        </b-col>
      </b-row>

      <user-list
        :users="users"
        @newUser="newUser"
        @userSelected="userSelected"
      />
    </div>

    <user
      v-if="user && state == 'EDIT'"
      :user="user"
      :availableRoles="availableRoles"
      @userUpdated="usUpdated"
      @cancel="cancel"
    ></user>
  </div>
</template>

<script>
import UserList from "@/views/Components/User/UserList.vue";
import User from "@/views/Components/User/User.vue";

export default {
  components: { UserList, User },
  props: {
    bindUsers: null,
    userUpdated: null,
    companyId: null,
    bindRoles: null,
  },
  data() {
    return {
      active: true,
      state: "VIEW",
      user: null,
      users: [],
      availableRoles: [],
    };
  },
  async mounted() {
    this.bind();
  },
  methods: {
    async bind() {
      let userDto = await this.bindUsers(this.active);
      this.availableRoles = userDto.availableRoles;
      this.users = userDto.users;
    },
    userSelected(user) {
      this.state = "EDIT";
      this.user = user;
    },
    async newUser() {
      this.state = "EDIT";

      this.availableRoles = await this.bindRoles();

      console.log(this.availableRoles);

      this.user = {
        isActive: true,
        roles: this.availableRoles.map((m) => m.key),
      };
    },
    cancel() {
      this.state = "VIEW";
    },
    async usUpdated(user) {
      this.state = "VIEW";
      await this.userUpdated(user);
      await this.bind();
    },
  },
};
</script>

<style></style>
